import React from 'react'
import { Helmet } from 'react-helmet'

export const Meta = () => (
  <Helmet>
    <meta name="robots" content="noindex" />
  </Helmet>
)

export default Meta
